import { CommonContentWrapper } from "../../common/components/content_wrapper/CommonContentWrapper";
import { Padding, SizedBox } from "../../common/components/CommonBaseComponents";
import { PageTitle } from "../../common/components/PageTitle";
import { useDevice } from "../../common/hooks/useDevice";
import Translate from "../../common/translate/Translate";
import DashboardGraphArea from "./components/DashboardGraphArea";
import DashboardBottomArea from "./components/DashboardBottomArea";
import FranchiseManagerDashboardTextCardArea from "./components/FranchiseManagerDashboardTextCardArea";
import AdminDashboardTextCardArea from "./components/AdminDashboardTextCardArea";
import AdminDashboardBottomArea from "./components/AdminDashboardBottmArea";
import CallCenterDashboardArea from "./components/CallCenterDashboardArea";
import Role from "../../common/enums/Role";
import LocalStorageKey from "../../common/enums/LocalStorageKey";

export function DashboardPage() {
    const currentDevice = useDevice();
    const role = localStorage.getItem(LocalStorageKey.role);

    if (role === Role.FranchiseManager) {
        return (
            <CommonContentWrapper>
                <Padding padding={currentDevice === "desktop" ? "24px 20px" : "24px 18px"}>
                    <PageTitle title={Translate("gnb.dashboard")} />
                    <FranchiseManagerDashboardTextCardArea />
                    <SizedBox height={"16px"} />
                    <DashboardGraphArea />
                    <SizedBox height={"16px"} />
                    <DashboardBottomArea />
                </Padding>
            </CommonContentWrapper>
        );
    } else if (role === Role.Admin) {
        return (
            <CommonContentWrapper>
                <Padding padding={currentDevice === "desktop" ? "24px 20px" : "24px 18px"}>
                    <PageTitle title={Translate("gnb.dashboard")} />
                    <AdminDashboardTextCardArea />
                    <SizedBox height={"16px"} />
                    <AdminDashboardBottomArea />
                </Padding>
            </CommonContentWrapper>
        );
        // } else if (role === Role.CallCenter) {
    } else {
        return (
            <CommonContentWrapper>
                <Padding padding={currentDevice === "desktop" ? "24px 20px" : "24px 18px"}>
                    <PageTitle title={Translate("gnb.dashboard")} />
                    <SizedBox height={"24px"} />
                    <CallCenterDashboardArea />
                </Padding>
            </CommonContentWrapper>
        );
    }
}
